import "../../FhAccordionPanel.css";
import { inject, ref, computed, openBlock, createElementBlock, normalizeClass, createVNode, unref, withCtx, createElementVNode, createBlock, createCommentVNode, renderSlot, withDirectives, vShow } from "vue";
import FhText from "../FhText/FhText.mjs";
import FhIcon from "../FhIcon/FhIcon.mjs";
import chevronDown from "../../icons/chevronDown.mjs";
import chevronUp from "../../icons/chevronUp.mjs";
import { generateUniqueId } from "../utils.mjs";
import { AccordionContextKey } from "../FhAccordion/Symbols.mjs";
import { DISPLAY_VARIANTS } from "./constants.mjs";
import { _ as _export_sfc } from "../../_plugin-vue_export-helper-1tPrXgE0.js";
const _hoisted_1 = ["aria-expanded", "disabled"];
const _hoisted_2 = ["hidden"];
const _sfc_main = {
  __name: "FhAccordionPanel",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: "",
      validator: (value) => value === "" || value.startsWith("<svg") && value.endsWith("</svg>")
    },
    name: {
      type: String,
      default: ""
    },
    titleVariant: {
      type: String,
      default: DISPLAY_VARIANTS.DISPLAY_MD,
      validator: (value) => Object.values(DISPLAY_VARIANTS).includes(value)
    }
  },
  setup(__props) {
    const props = __props;
    const accordionContext = inject(AccordionContextKey, null);
    const localIsOpen = ref(false);
    const uniqueId = generateUniqueId();
    const computedPanelName = computed(() => props.name || `fh-panel-${uniqueId}`);
    const isOpen = computed(() => {
      var _a;
      if (accordionContext) {
        return (_a = accordionContext.modelValue) == null ? void 0 : _a.value.includes(computedPanelName.value);
      }
      return localIsOpen.value;
    });
    const togglePanel = () => {
      if (accordionContext) {
        accordionContext.toggleItem(computedPanelName.value);
      } else {
        localIsOpen.value = !localIsOpen.value;
      }
    };
    const headingId = `fh-accordion-heading--${uniqueId}`;
    const contentId = `fh-accordion-content--${uniqueId}`;
    const computedIcon = computed(() => isOpen.value ? chevronUp : chevronDown);
    const computedPanelClasses = computed(() => [
      "fh-accordion-item",
      props.disabled && "fh-accordion-item--disabled",
      (accordionContext == null ? void 0 : accordionContext.divider.value) && "fh-accordion-item--divider"
    ]);
    const computedIconColor = computed(
      () => props.disabled ? "disabled" : "default"
    );
    const computedTextColor = computed(
      () => props.disabled ? "disabled" : "default"
    );
    return (_ctx, _cache) => {
      var _a;
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(computedPanelClasses.value)
      }, [
        createVNode(FhText, {
          tag: (_a = unref(accordionContext)) == null ? void 0 : _a.tag.value,
          variant: props.titleVariant,
          weight: "medium",
          class: "fh-accordion-heading",
          color: computedTextColor.value
        }, {
          default: withCtx(() => [
            createElementVNode("button", {
              type: "button",
              class: "fh-accordion-button",
              id: headingId,
              "aria-expanded": isOpen.value,
              "aria-controls": contentId,
              onClick: togglePanel,
              disabled: props.disabled
            }, [
              props.icon ? (openBlock(), createBlock(FhIcon, {
                key: 0,
                icon: props.icon,
                color: computedIconColor.value
              }, null, 8, ["icon", "color"])) : createCommentVNode("", true),
              renderSlot(_ctx.$slots, "default", {}, void 0, true),
              createVNode(FhIcon, {
                class: "fh-accordion-chevron",
                icon: computedIcon.value,
                size: "sm"
              }, null, 8, ["icon"])
            ], 8, _hoisted_1)
          ]),
          _: 3
        }, 8, ["tag", "variant", "color"]),
        withDirectives(createElementVNode("div", {
          hidden: !isOpen.value,
          id: contentId,
          class: "fh-accordion-content",
          role: "region",
          "aria-labelledby": headingId
        }, [
          renderSlot(_ctx.$slots, "panel", {}, void 0, true)
        ], 8, _hoisted_2), [
          [vShow, isOpen.value]
        ])
      ], 2);
    };
  }
};
const FhAccordionPanel = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-acae32f2"]]);
export {
  FhAccordionPanel as default
};
//# sourceMappingURL=FhAccordionPanel.mjs.map
